import React, { Component } from "react";
import styled from "styled-components";

import { Icon } from "../../../../Components/Icon";
import { IconButton } from "../../../../Components/IconButton";
import { ToolTip } from "../../../../Components/ToolTip";
import Spinner from "../../../../react/components/Spinner";

const FileEntryContainer = styled.div`
    position: relative;
    display: flex;
    gap: 5px;
    color: ${props => props.color};
    background: ${props => props.background};
    font-size: 14px;
    border: solid 1px #888;
    padding: 2px 5px;
    border-radius: 10px;
    align-items: center;
    user-select: none;
    font-weight: 400;

    &.processing {
        opacity: 0.7;
    }
`;

const FileEntryButton = styled(IconButton)`
    height: 16px;
    width: 16px;
    min-width: 16px;
    border-radius: 50%;

    &:hover {
        background: rgba(0, 0, 0, 0.2);
    }
`;

class FileEntry extends Component {
    render() {
        let { file, disabled, color = "#333", background = "transparent", hideButton = false, onRemove } = this.props;

        let Content = (
            <FileEntryContainer className={file.isProcessing ? "processing" : ""} color={color} background={background}>
                {file.isProcessing &&
                    <div style={{ position: "relative", width: 25, height: 20, transform: "scale(0.8)", marginRight: -5 }}>
                        <Spinner small />
                    </div>
                }
                {file.hasBeenUsed && (
                    <Icon>check_circle</Icon>
                )}
                {!file.isProcessing && !file.hasBeenUsed && (
                    <Icon>upload_file</Icon>
                )}
                {file.name}
                {!file.isProcessing && !file.hasBeenUsed && !hideButton && (
                    <FileEntryButton icon="close" size={16} onClick={() => onRemove(file)} disabled={disabled} />
                )}
            </FileEntryContainer>
        );

        if (file.hasBeenUsed) {
            let hasBeenUsedForDescription = "";
            if (file.hasBeenUsedFor === "outline") {
                hasBeenUsedForDescription = "This file has been used to generate the outline";
            } else if (file.hasBeenUsedFor === "edit") {
                hasBeenUsedForDescription = "This file has been used to update the outline";
            } else if (file.hasBeenUsedFor === "slide") {
                hasBeenUsedForDescription = "This file has been used to generate the slide ideas";
            }

            return (
                <ToolTip title={hasBeenUsedForDescription}>
                    {Content}
                </ToolTip>
            );
        }

        return Content;
    }
}

export default FileEntry;
